;
define("product_details_full.tpl", function(){});

